import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './plugins/fontawesome.js'
import notificationPlugin from '@/components/generic/notification/notificationPlugin.js'
import i18n from "./i18n/index.js"
import "preline/preline";

const pinia = createPinia()
import router from '@/router';
import App from '@/layouts/App.vue'
import filters from '@/filters/index.js'
import '../css/app.css';
import './plugins/axios.js';
import './plugins/fontawesome.js'
pinia.use(({ store }) => {
  store.router = markRaw(router)
})
const app = createApp(App)

app.use(pinia)
  .use(notificationPlugin)
  .use(router)
  .use(i18n)
  .component('icon',FontAwesomeIcon)
  .mount('#app');

app.config.globalProperties.$filters = filters.reduce((obj, filter) => {
  obj[filter.name] = filter.execute
  return obj
}, {})

